var confettiTriggered = false; // Track if confetti has already exploded

var selectedVariant = null; // Declare globally (var for inline script access)

// Define URLs for NS (before reveal) and non-NS (after reveal) active and inactive images
const nsInactiveImages = [
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NS_1B_Inactive.png?v=1734131233',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NS_3B_Inactive.png?v=1734131233',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NS_240B_Inactive.png?v=1734131233'
];

const nsActiveImages = [
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NS_1B_Active.png?v=1734131217',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NS_3B_Active.png?v=1734131217',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NS_240B_Active.png?v=1734131217'
];

const inactiveImages = [
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NB_NAD3_60_Inactive.png?v=1733949239',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NB_NAD3_60_3b_Inactive.png?v=173394923',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NB_NAD3_240_Inactive.png?v=1733949239'
];

const activeImages = [
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NB_-_NAD3_60_Active.png?v=1733950402',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NB_-_NAD3_60_3b_Active.png?v=1733950401',
    'https://cdn.shopify.com/s/files/1/2443/2395/files/NB_-_NAD3_240_Active.png?v=1733950402'
];

// ── NEW: subscription‐state variant images ──
const subInactiveImages = [
  'https://cdn.shopify.com/s/files/1/2443/2395/files/1pck_Sub_-_Inactive.png?v=1748409178',
  'https://cdn.shopify.com/s/files/1/2443/2395/files/3pck_Sub_-_Inactive.png?v=1748409180',
  'https://cdn.shopify.com/s/files/1/2443/2395/files/240_Sub_-_Inactive.png?v=1748409182'
];
const subActiveImages = [
  'https://cdn.shopify.com/s/files/1/2443/2395/files/1pck_Sub_-_Active.png?v=1748409185',
  'https://cdn.shopify.com/s/files/1/2443/2395/files/3pck_Sub_-_Active.png?v=1748409188',
  'https://cdn.shopify.com/s/files/1/2443/2395/files/240_Sub_-_Active.png?v=1748409190'
];

// Shared state to track if the discount has been revealed (global for inline scripts)
var discountRevealed = false;

// Define discounts for each variant by ID
const discounts = {
    '21174522675284': 'SAVE 20%',
    '21174522708052': 'SAVE 25%',
    '39922146705545': 'SAVE 28%'
};
  
document.addEventListener('DOMContentLoaded', function() {

document.querySelector('.cust-installment-message-container').style.display = 'none';
document.querySelector('.free-shipping-callout').style.display = 'none';
document.querySelector('.cust-compare-price').style.display = 'none';  
// Native ATC link - NO LONGER HIDING IT
// Buttons always visible now

// Parse the embedded product data
var productData = JSON.parse(document.getElementById('ProductData').innerHTML);

// Create a mapping from variant ID to variant data
var variantDataById = {};
productData.variants.forEach(function(variant) {
  variantDataById[variant.id.toString()] = variant;
});

// Debugging log
console.log('Variant Data By ID:', variantDataById);

const variantImages = document.querySelectorAll('.cust-variant-images img');
const titleElement = document.querySelector('.cust-title');
const bundleSaveMessageElement = document.querySelector('.cust-bundle-save-message');
const comparePriceElement = document.querySelector('.cust-compare-price');
const priceElement = document.querySelector('.cust-price');
const savePriceElement = document.querySelector('.cust-save-price');
const installmentMessageElement = document.querySelector('.cust-installment-message');
const addToCartButton = document.querySelector('a.cust-add-to-cart'); // Only select the <a> link, not form buttons

// FREEBIES CALLOUT
const freeItemsCallout = document.getElementById('free-items-callout');
const freeShippingMessage = document.getElementById('free-shipping-message');
const defaultCalloutImage = document.getElementById('default-free-items-callout');

const variants = {
  variant1: {
      id: '21174522675284',
      title: 'NAD3® | 1 Month Supply',
      bundleSaveMessage: '<span>Bundle & Save:</span> Single Item',
      comparePrice: '$52.99', // Full price before reveal
      originalPrice: '$52.99', // Display this before reveal
      price: '$42.00', // Display this after reveal
      savePrice: 'SAVE 20%',
      installmentMessage: 'or 4 interest-free installments of <span>$10.50</span> with',
      imageSrc: 'https://cdn.shopify.com/s/files/1/2443/2395/files/1_Bottle_BTN_NAD3_60_-_ACTIVE.png?v=1726107755',
      addToCartUrl: '/cart/add?id=21174522675284',
      freeShippingMessage: `<strong>Congrats!</strong> You're getting our <strong>Longevity eBook</strong> ($20 value) for <strong>FREE!</strong>`,
      freeItemsCalloutSrc: 'https://cdn.shopify.com/s/files/1/2443/2395/files/Freebies_Callout_1.0.png?v=1726095946'
  },
  variant2: {
      id: '21174522708052',
      title: 'NAD3® | 3 Months Supply',
      bundleSaveMessage: '<span>Bundle & Save:</span> 3 Pack',
      comparePrice: '$158.97',
      originalPrice: '$158.97',
      price: '$119.00',
      savePrice: 'SAVE 25%',
      installmentMessage: 'or 4 interest-free installments of <span>$29.75</span> with',
      imageSrc: 'https://cdn.shopify.com/s/files/1/2443/2395/files/3_Bottles_BTN_NAD3_60_-_ACTIVE.png?v=1726107754',
      addToCartUrl: '/cart/add?id=21174522708052',
      freeShippingMessage: `<strong>Congrats!</strong> You're getting our <strong>Longevity eBook</strong> and our <strong>Priority Processing + Shipping</strong> ($45 value) for <strong>FREE!</strong>`,
      freeItemsCalloutSrc: 'https://cdn.shopify.com/s/files/1/2443/2395/files/Freebies_Callout_2.0.png?v=1726095946'
  },
  variant3: {
      id: '39922146705545',
      title: 'NAD3® | 4 Months Supply',
      bundleSaveMessage: '<span>Bundle & Save:</span> Value Size',
      comparePrice: '$211.96',
      originalPrice: '$211.96',
      price: '$156.00',
      savePrice: 'SAVE 28%',
      installmentMessage: 'or 4 interest-free installments of <span>$39</span> with',
      imageSrc: 'https://cdn.shopify.com/s/files/1/2443/2395/files/240_Bottle_BTN_NAD3_60_-_ACTIVE.png?v=1726107779',
      addToCartUrl: '/cart/add?id=39922146705545',
      freeShippingMessage: `<strong>Congrats!</strong> You're getting our <strong>Longevity eBook</strong>, our <strong>Priority Processing + Shipping</strong>, and a bottle of <strong>S9</strong> ($75 value) for <strong>FREE!</strong>`,
      freeItemsCalloutSrc: 'https://cdn.shopify.com/s/files/1/2443/2395/files/Freebies_Callout_3.png?v=1726095734'
  }
};

function updateProductInfo(variant) {
  titleElement.innerHTML = variant.title;
  bundleSaveMessageElement.innerHTML = variant.bundleSaveMessage;
  comparePriceElement.innerHTML = variant.comparePrice;
  
  // Use original price before reveal, discounted price after reveal
  if (discountRevealed) {
      priceElement.innerHTML = variant.price;
  } else {
      priceElement.innerHTML = variant.originalPrice;
  }

  installmentMessageElement.innerHTML = `${variant.installmentMessage}`;
  addToCartButton.href = variant.addToCartUrl;
  freeShippingMessage.innerHTML = variant.freeShippingMessage;
  freeItemsCallout.src = variant.freeItemsCalloutSrc;
  freeItemsCallout.style.display = 'block';
  defaultCalloutImage.style.display = 'none';
  // selectedVariant is set by the caller, not here

  const freeShippingMessage2 = document.getElementById('free-shipping-message-2');
  if (variant === variants.variant1) {
      freeShippingMessage2.innerHTML = "$20 in FREE Value included with this order!";
  } else if (variant === variants.variant2) {
      freeShippingMessage2.innerHTML = "$45 in FREE Value included with this order!";
  } else if (variant === variants.variant3) {
      freeShippingMessage2.innerHTML = "$75 in FREE Value included with this order!";
  }

  // Update discount display
  document.querySelectorAll('.cust-save-price').forEach(saveElement => {
      saveElement.setAttribute('data-variant-id', variant.id);
      if (discountRevealed) {
          saveElement.classList.remove('reveal');
          saveElement.innerHTML = discounts[variant.id] || 'SAVE';
          saveElement.removeAttribute('id'); // Remove ID when showing "SAVE XX%"
      } else {
          saveElement.classList.add('reveal');
          saveElement.innerHTML = 'REVEAL DISCOUNT';
          saveElement.id = 'reveal-discount-button'; // Assign unique ID
          saveElement.removeEventListener('click', toggleAllDiscounts);
          saveElement.addEventListener('click', toggleAllDiscounts);
      }
  });

  variantImages.forEach((img, index) => {
      if (discountRevealed) {
          img.src = (variant === variants.variant1 && index === 0) ? activeImages[0] :
                    (variant === variants.variant2 && index === 1) ? activeImages[1] :
                    (variant === variants.variant3 && index === 2) ? activeImages[2] :
                    inactiveImages[index];
      } else {
          img.src = (variant === variants.variant1 && index === 0) ? nsActiveImages[0] :
                    (variant === variants.variant2 && index === 1) ? nsActiveImages[1] :
                    (variant === variants.variant3 && index === 2) ? nsActiveImages[2] :
                    nsInactiveImages[index];
      }
      
  });

  // Availability check
  const variantData = variantDataById[variant.id.toString()];
  if (!variantData || !variantData.available) {
      addToCartButton.classList.add('disabled');
      addToCartButton.innerHTML = '<div class="cust-add-to-cart-content">SOLD OUT</div>';
      addToCartButton.href = '#';
  } else {
      addToCartButton.classList.remove('disabled');
      addToCartButton.innerHTML = '<div class="cust-add-to-cart-content">ADD TO CART<div class="secure-checkout-container"><img src="https://cdn.shopify.com/s/files/1/2443/2395/files/Icon_-_Secure_Checkout.png?v=1717709889" alt="Secure Checkout"><span class="secure-checkout-text">100% Secure Checkout</span></div></div>';
      addToCartButton.href = variant.addToCartUrl;
  }

  // Delegate to updateOCUFormsVisibility - NO HIDING OF BUTTONS HERE
  if (typeof updateOCUFormsVisibility === 'function') {
    updateOCUFormsVisibility();
  }
}


// Initial load with Variant 1 active
updateProductInfo(variants.variant2);
selectedVariant = variants.variant2; // Set initial selected variant

// Note: Native form submission is used for all add-to-cart buttons
// The theme will handle cart drawer or cart page behavior based on settings

function toggleAllDiscounts(event) {
  // Prevent multiple triggers
  if (discountRevealed) return;

  // Set discountRevealed to true when any "REVEAL DISCOUNT" button is clicked
  discountRevealed = true;

  // Remove the event listener from the button (only if event is provided)
  if (event && event.currentTarget) {
    event.currentTarget.removeEventListener('click', toggleAllDiscounts);
  }

  // Only trigger confetti on the first click
  if (!confettiTriggered) {
      confettiTriggered = true; // Set flag to true after the first confetti explosion

      // Adjust particle size and position for desktop
      const confettiOptions = {
          particleCount: 100,
          spread: 70,
          origin: { 
              y: 0.6, 
              x: window.innerWidth > 1024 ? 0.7 : 0.5  // Shift right on desktop screens
          },
          colors: ['#082944', '#ffc106', '#3f84ae'],
          scalar: window.innerWidth > 1024 ? 1.5 : 1 // Larger particles on desktop
      };

      // Trigger the confetti explosion
      confetti(confettiOptions);
  }

  // REMOVE PRICE BLUR 
  document.querySelector('.cust-price').classList.add('unblur');

  // ✅ SHOW SUBSCRIBE WRAPPER IMMEDIATELY ON REVEAL (before any variant selection)
  const subscribeWrapper = document.querySelector('.subscribe-wrapper');
  if (subscribeWrapper) subscribeWrapper.style.display = 'block';
  
  const subscribeToggleContainer = document.querySelector('.cust-subscribe-toggle-container');
  if (subscribeToggleContainer) subscribeToggleContainer.style.display = 'flex';

  // Update each .cust-save-price element with the correct discount based on its variant ID
  document.querySelectorAll('.cust-save-price').forEach((saveElement) => {
      const variantId = saveElement.getAttribute('data-variant-id');
      saveElement.classList.remove('reveal');
      saveElement.innerHTML = discounts[variantId] || 'SAVE';
  });

  // Reveal the hidden elements
  document.querySelector('.cust-installment-message-container').style.display = 'flex';
  document.querySelector('.free-shipping-callout').style.display = 'block';
  document.querySelector('.cust-compare-price').style.display = 'block';
  
  // Update subscribe callout text based on selected variant
  const subscribeCallout = document.querySelector('.cust-subscribe-callout');
  if (subscribeCallout && selectedVariant) {
    let calloutText = '';
    switch (selectedVariant.id) {
      case '21174522675284':
        calloutText = 'Save 25% on MSRP for Subscribing. Cancel anytime!';
        break;
      case '21174522708052':
        calloutText = 'Save 29% on MSRP for Subscribing. Cancel anytime!';
        break;
      case '39922146705545':
        calloutText = 'Save 30% on MSRP for Subscribing. Cancel anytime!';
        break;
    }
    subscribeCallout.textContent = calloutText;
  }
  
  // Update subscribe popup headings/text based on selected variant
  const popupHeading = document.getElementById('subscribe-popup-heading');
  const popupText = document.getElementById('subscribe-popup-text');
  const mobileHeading = document.getElementById('subscribe-popup-mobile-heading');
  const mobileText = document.getElementById('subscribe-popup-mobile-text');
  if (selectedVariant) {
    let heading = '';
    let desc = '';
    switch (selectedVariant.id) {
      case '21174522675284':
        heading = 'Subscribe & Save 25% Instantly—Plus Free Shipping';
        desc = "When you subscribe to NAD3, you unlock 25% OFF MSRP every time, plus free shipping on every order. It's our best deal—no gimmicks, no strings attached.";
        break;
      case '21174522708052':
        heading = 'Subscribe & Save 29% Instantly—Plus Free Shipping';
        desc = "When you subscribe to NAD3, you unlock 29% OFF MSRP every time, plus free shipping on every order. It's our best deal—no gimmicks, no strings attached.";
        break;
      case '39922146705545':
        heading = 'Subscribe & Save 30% Instantly—Plus Free Shipping';
        desc = "When you subscribe to NAD3, you unlock 30% OFF MSRP every time, plus free shipping on every order. It's our best deal—no gimmicks, no strings attached.";
        break;
    }
    if (popupHeading) popupHeading.textContent = heading;
    if (popupText) popupText.textContent = desc;
    if (mobileHeading) mobileHeading.textContent = heading;
    if (mobileText) mobileText.textContent = desc;
  }
  
  // After discount reveal, let updateOCUFormsVisibility handle button visibility
  // Don't show native link here - the function will show correct form/button
  document.querySelector('.cust-reveal-discount-button').style.display = 'none';
  
  // Call updateOCUFormsVisibility to show the correct form
  if (typeof updateOCUFormsVisibility === 'function') {
    updateOCUFormsVisibility();
  }

  // Add fade-in animation to revealed elements
  document.querySelector('.cust-installment-message-container').classList.add('fade-in');
  document.querySelector('.free-shipping-callout').classList.add('fade-in');
  document.querySelector('.cust-compare-price').classList.add('fade-in');

  // Immediately update images to non-NS set: selected variant active, others inactive
  variantImages.forEach((img, index) => {
      img.src = (index === 0 && selectedVariant.id === variants.variant1.id) ? activeImages[0] :
                (index === 1 && selectedVariant.id === variants.variant2.id) ? activeImages[1] :
                (index === 2 && selectedVariant.id === variants.variant3.id) ? activeImages[2] :
                inactiveImages[index];
    
      // **ADD IMAGE-FLARE ANIMATION HERE**
      img.classList.add('image-flair');

      // Remove the class after the animation completes to allow re-triggering
      setTimeout(() => {
          img.classList.remove('image-flair');
      }, 500); // Duration matches the CSS animation duration
  });

  // Update product info to reflect the new prices after the reveal
  updateProductInfo(selectedVariant);

  // **Add Fade-In Animation to the Price**
  priceElement.classList.add('fade-in');

  // Remove the class after the animation completes to allow re-triggering
  setTimeout(() => {
      priceElement.classList.remove('fade-in');
  }, 1000); // Duration matches the CSS animation duration

  // Update OCU forms visibility (critical for showing add to cart buttons)
  // Use setTimeout to ensure inline scripts have loaded
  setTimeout(() => {
    if (typeof updateOCUFormsVisibility === 'function') {
      updateOCUFormsVisibility();
    }
  }, 50);
}


// Add click event listeners to the variant images
variantImages[0].addEventListener('click', () => {
  selectedVariant = variants.variant1; // Update selectedVariant FIRST
  updateProductInfo(variants.variant1);
  
  // Update OCU forms and subscribe popup immediately
  if (typeof updateOCUFormsVisibility === 'function') updateOCUFormsVisibility();
  if (typeof updateSubscribePopup === 'function') updateSubscribePopup();
  
  // Enable variant 1 floating behavior
  if (typeof enableVariant1Floating === 'function') enableVariant1Floating();
  
  // Update pricing if subscribe is checked
  const subscribeToggle = document.getElementById('cust-subscribe-toggle');
  if (subscribeToggle && subscribeToggle.checked && typeof updatePricingCallouts === 'function') {
    updatePricingCallouts();
  }

  // Hide the global floating buttons
  const mobileFloatingButton = document.getElementById("FloatingAddToCartButton");
  const desktopFloatingButton = document.getElementById("DesktopFloatingAddToCartButton");
  if (mobileFloatingButton) mobileFloatingButton.style.display = 'none';
  if (desktopFloatingButton) desktopFloatingButton.style.display = 'none';

  // Button visibility is handled by updateOCUFormsVisibility()
});

variantImages[1].addEventListener('click', () => {
  selectedVariant = variants.variant2; // Update selectedVariant FIRST
  updateProductInfo(variants.variant2);
  
  // Update OCU forms and subscribe popup immediately
  if (typeof updateOCUFormsVisibility === 'function') updateOCUFormsVisibility();
  if (typeof updateSubscribePopup === 'function') updateSubscribePopup();
  
  // Disable variant 1 floating, enable variant 2
  if (typeof disableVariant1Floating === 'function') disableVariant1Floating();
  if (typeof enableVariant2Floating === 'function') enableVariant2Floating();
  
  // Update pricing if subscribe is checked
  const subscribeToggle = document.getElementById('cust-subscribe-toggle');
  if (subscribeToggle && subscribeToggle.checked && typeof updatePricingCallouts === 'function') {
    updatePricingCallouts();
  }

  // Hide the global floating buttons
  const mobileFloatingButton = document.getElementById("FloatingAddToCartButton");
  const desktopFloatingButton = document.getElementById("DesktopFloatingAddToCartButton");
  if (mobileFloatingButton) mobileFloatingButton.style.display = 'none';
  if (desktopFloatingButton) desktopFloatingButton.style.display = 'none';
});

variantImages[2].addEventListener('click', () => {
  selectedVariant = variants.variant3; // Update selectedVariant FIRST
  updateProductInfo(variants.variant3);
  
  // Update OCU forms and subscribe popup
  if (typeof updateOCUFormsVisibility === 'function') updateOCUFormsVisibility();
  if (typeof updateSubscribePopup === 'function') updateSubscribePopup();
  
  // Disable variant 1 floating
  if (typeof disableVariant1Floating === 'function') disableVariant1Floating();
  
  // Update pricing if subscribe is checked
  const subscribeToggle = document.getElementById('cust-subscribe-toggle');
  if (subscribeToggle && subscribeToggle.checked && typeof updatePricingCallouts === 'function') {
    updatePricingCallouts();
  }

  // Button visibility is handled by updateOCUFormsVisibility()
});

// Add event listener to the fake Add To Cart button
document.querySelector('.cust-reveal-discount-button').addEventListener('click', function(event) {
  event.preventDefault(); // Prevent default link behavior
  event.stopPropagation(); // Stop event bubbling
  toggleAllDiscounts(event);   // Call the function to reveal discounts, passing the event
});

// Add event listener to the subscribe toggle checkbox
const subscribeToggleCheckbox = document.getElementById('cust-subscribe-toggle');
if (subscribeToggleCheckbox) {
  subscribeToggleCheckbox.addEventListener('change', function() {
    // Update forms visibility based on subscribe state
    if (typeof updateOCUFormsVisibility === 'function') {
      updateOCUFormsVisibility();
    }
    // Update pricing callouts based on subscribe state
    if (typeof updatePricingCallouts === 'function') {
      updatePricingCallouts();
    }
    
    // Hide/show FloatingAddToCartButton based on subscribe state
    const floatingButton = document.getElementById('FloatingAddToCartButton');
    if (floatingButton) {
      if (this.checked) {
        // Subscription checked - hide floating button
        floatingButton.style.display = 'none';
      } else {
        // Subscription unchecked - show floating button
        floatingButton.style.display = '';
      }
    }
  });
}

}); // END DOMContentLoaded
